import React from "react";

interface CorsErrorMessageProps {
	error: Error;
	hostname: string;
}

export default function CorsErrorMessage({
	error,
	hostname,
}: CorsErrorMessageProps) {
	const isSlugError = error.message.includes("iframe embedding");
	const isThemeError = error.message.includes("theme");

	const corsHelpText = `
## CORS Error - External Domain Configuration Needed

Your app is running on **${hostname}**, which is not configured for ShapeDiver CORS access.

### Quick Fixes:

${
	isSlugError
		? `
#### For Model Loading:
Instead of using \`slug\` parameter, use \`ticket\` and \`modelViewUrl\`:

**Current URL pattern (failing):**
\`?slug=your-model-slug\`

**Working URL pattern:**
\`?ticket=YOUR_TICKET&modelViewUrl=YOUR_MODEL_VIEW_URL\`

To get these values:
1. Go to your model's [Developer Settings](https://help.shapediver.com/doc/developers-settings) on ShapeDiver
2. Enable "Direct Embedding" 
3. Copy the "Embedding Ticket" and "Model View URL"
4. Update your URL parameters
`
		: ""
}

${
	isThemeError
		? `
#### For Theme Files:
Theme file loading failed due to CORS restrictions. The app will use a default theme instead.
`
		: ""
}

### Long-term Solution:
Configure your domain for ShapeDiver embedding:
1. Contact ShapeDiver support to whitelist **${hostname}**
2. Or use the ShapeDiver-hosted version at [appbuilder.shapediver.com](https://appbuilder.shapediver.com)

### Error Details:
\`\`\`
${error.message}
\`\`\`
`;

	return (
		<div
			style={{
				padding: "20px",
				backgroundColor: "#fee",
				border: "1px solid #fcc",
				borderRadius: "8px",
				fontFamily: "system-ui, -apple-system, sans-serif",
			}}
		>
			<div
				dangerouslySetInnerHTML={{
					__html: corsHelpText.replace(/\n/g, "<br/>"),
				}}
			/>
		</div>
	);
}
